import { createAction } from 'redux-actions';

export const SET_DATA = 'SET_DATA';

export const setEasyBookingData = {
  setData: createAction(SET_DATA),
};
